exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.splash-preview[data-v-16f74e12] { display: block; max-width: 120px; max-height: 200px; margin-top: 8px; border-radius: 4px;\n}\r\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/appsetting/appopen/part/splash/Edit.vue"],"names":[],"mappings":";AACA,mCAAmC,eAAe,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,mBAAmB;CAC3H","file":"Edit.vue","sourcesContent":["\n.splash-preview[data-v-16f74e12] { display: block; max-width: 120px; max-height: 200px; margin-top: 8px; border-radius: 4px;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16f74e12","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/appsetting/appopen/part/splash/Edit.vue
// module id = YogH
// module chunks = 0